import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  noIndex?: boolean;
  schemaJson?: Record<string, any>[];
}

export function SEOHead({
  title,
  description,
  canonical,
  ogImage = "https://assets.cdn.filesafe.space/2uky3JASjEkhr90sRnhQ/media/6a55419e524a3ec4c63ba0db.png",

  noIndex,
  schemaJson,
}: SEOHeadProps) {
  const location = useLocation();
  const baseUrl = "https://www.saskroofingcompany.com";
  const canonicalUrl = canonical
    ? canonical.startsWith("http")
      ? canonical
      : `${baseUrl}${canonical}`
    : `${baseUrl}${location.pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:site_name" content="Sask Roofing Company" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:type" content="website" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {schemaJson &&
        schemaJson.length > 0 &&
        schemaJson.map((schema, index) => (
          <script type="application/ld+json" key={index}>
            {JSON.stringify(schema)}
          </script>
        ))}
    </Helmet>
  );
}
